/**
 * NegotiationThread
 *
 * The conversational half of the breakdown review (FLOW-549): a transcript
 * of revision requests and the AI's replies, beside the proposal itself. A
 * separate conversation from the intake's clarifying thread — see the design
 * doc — so this reuses the shared message markup (`MessageList`) and
 * composer (`IntakeComposer`) rather than the intake thread's progress rail.
 */

import { Component } from "solid-js";
import type { Message } from "../../api/types";
import { MessageList } from "./MessageList";
import { IntakeComposer } from "./IntakeComposer";

export interface NegotiationThreadProps {
  messages: Message[];
  /** Message awaiting a reply — echoed before the backend has persisted it */
  pending: string | null;
  /** True while the AI is working */
  busy: boolean;
  /** Resolves true when the turn succeeded and the composer should clear */
  onSubmit: (content: string) => Promise<boolean>;
}

export const NegotiationThread: Component<NegotiationThreadProps> = (props) => (
  <div class="flex flex-col gap-4 p-6">
    <h2 class="text-sm font-semibold text-ink">Negotiate</h2>

    <div class="flex-1 overflow-y-auto">
      <MessageList
        messages={props.messages}
        pending={props.pending}
        busy={props.busy}
      />
    </div>

    <IntakeComposer
      disabled={props.busy}
      placeholder="Ask to add, remove, split, or reframe a story…"
      aria-label="Negotiate the breakdown"
      submitLabel="Send"
      onSubmit={props.onSubmit}
    />
  </div>
);

export default NegotiationThread;
